import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../../axiosInstance";
import {  motorApiEndpoints } from "../../../api";


export const RemoveBank = createAsyncThunk(
    "RemoveBank",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling API...")
            const response = await Axios.post(`${motorApiEndpoints.removeBank}`, payload);
            console.log("response is: ", response.data)

            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const initialState = {
    removeBank: null,
    status: 'idle', // idle | loading | succeeded | failed
    error: null
  }

  const RemoveBankSlice = createSlice({
    name: 'RemoveBank',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(RemoveBank.pending, (state) =>{
            state.status = 'loading';
        })
        .addCase(RemoveBank.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.removeBank = action.payload;
        })
        .addCase(RemoveBank.rejected, (state, action) =>{
            state.status = 'failed';
            state.error = action.error.message;
        })
    }
  });

export default RemoveBankSlice.reducer;
